<template>
  <v-container>
    <v-row>
      <v-col cols="6" sm="4">
        <v-autocomplete
          variant="underlined"
          v-model="selectedGroup"
          :items="groups"
          item-title="name"
          item-value="id"
          label="Выберите группу"
          @update:model-value="getGroupData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex align-center justify-center">
        <v-btn
          icon="mdi-arrow-left"
          size="x-small"
          variant="text"
          @click="decDate()"
        >
        </v-btn>
        <v-menu
          v-model="dateMenu"
          transition="scale-transition"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ props }">
            <span v-bind="props" class="cursor-pointer">{{ dayStr }}</span>
          </template>
          <v-locale-provider locale="ru">
            <v-date-picker
              hide-header
              bg-color="grey-lighten-5"
              :max="semesterSettings ? semesterSettings.end : null"
              :min="semesterSettings ? semesterSettings.begin : null"
              v-model="selectedDate"
              no-title
              @update:modelValue="dateMenu = false"
            ></v-date-picker>
          </v-locale-provider>
        </v-menu>
        <v-btn
          icon="mdi-arrow-right"
          size="x-small"
          variant="text"
          @click="incDate()"
        >
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="lesson in lessons" :key="lesson.id" cols="12" sm="6" md="4">
        <v-card>
          <v-card-title class="text-h6">
            {{ lesson.lesson }} пара
          </v-card-title>
          <v-card-subtitle class="text-h6">
            {{ lesson.teacher }}
          </v-card-subtitle>
          <v-card-actions>
            <v-btn
              :append-icon="
                lessonShow[lesson.id] ? 'mdi-chevron-up' : 'mdi-chevron-down'
              "
              @click="lessonShow[lesson.id] = !lessonShow[lesson.id]"
              color="primary"
            >
              <span>
                <div class="mb-1">Показать</div>
              </span>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <div v-show="lessonShow[lesson.id]">
              <v-card-text>
                <div
                  v-for="student in lesson.students"
                  :key="student.user_id"
                  class="pa-3 mb-3 rounded-lg"
                  style="border: 1px solid #ddd"
                >
                  <div class="font-weight-medium mb-2">
                    {{ student.name }}
                  </div>

                  <v-row dense>
                    <v-col cols="6">
                      <v-text-field
                        v-model="student.hours"
                        label="Часы"
                        type="text"
                        inputmode="numeric"
                        min="0"
                        variant="outlined"
                        density="compact"
                        hide-details
                        @update:modelValue="debouncedSaveLesson(lesson)"
                        @keypress="
                          /^\d$/.test($event.key) || $event.preventDefault()
                        "
                        @paste="$event.preventDefault()"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-select
                        v-model="student.attend"
                        :items="attendOptions"
                        item-title="title"
                        item-value="id"
                        label="Причина"
                        variant="outlined"
                        density="compact"
                        hide-details
                        @update:modelValue="debouncedSaveLesson(lesson)"
                      ></v-select>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      v-model="processData"
      persistent
      class="align-center justify-center"
    >
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import { useDate } from "vuetify";
import debounce from "lodash/debounce";
import eventBus from "moodleDir/procollege/lib/vue/EventBus.js";
export default {
  data() {
    return {
      rules: {
        numbers: [
          (value) => {
            const pattern = /^(\s*|\d+)$/;
            return pattern.test(value) || "Только число";
          },
        ],
      },

      dateMenu: false,
      dayStr: "",
      semesterSettings: null,
      selectedDate: null,
      load: false,
      day: 0,
      groups: [],
      selectedGroup: null,
      processData: false,
      attendOptions: [],
      lessons: [],
      abortControl: [],
      keyPressedmsAgo: false,
      sendingDataHandler: false,
      lessonShow: {},
    };
  },
  watch: {
    day: function (newVal, oldVal) {
      let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      this.dayStr = this.day.toLocaleDateString("ru-RU", options);
      if (this.selectedGroup) {
        this.getGroupData(this.selectedGroup);
      }
    },
    selectedDate: function (newVal, oldVal) {
      this.day = new Date(newVal);
    },
  },
  created() {
    
    this.getGroups();
    this.loadSemesterSettings();
  },
  methods: {
    getGroups() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/secretariat/attendanceReport/getGroups"
        )
        .then((response) => {
          this.groups = response.data;
          if (this.groups.length == 1) {
            this.selectedGroup = response.data[0].id;
            this.getGroupData(this.selectedGroup);
          }
        });
    },
    loadSemesterSettings() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/core_procollege/helpers/TimetableHelper/timetableGetSemesterDates"
        )
        .then((response) => {
          this.semesterSettings = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.day = new Date();
      this.dateFormatter = useDate();
    },
    incDate() {
      this.day.setDate(this.day.getDate() + 1);
      this.day = new Date(this.day);
    },
    decDate() {
      this.day.setDate(this.day.getDate() - 1);
      this.day = new Date(this.day);
    },
    getGroupData(group_id) {
      this.processData = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/secretariat/attendanceReport/getTimetable",
          new URLSearchParams({
            dayStr: this.day.toLocaleDateString("en-US"),
            groupid: group_id,
          })
        )
        .then((response) => {
          this.lessons = response.data.lesson;
          this.lessonShow = Object.fromEntries(
            this.lessons.map((lesson) => [lesson.id, false])
          );
          this.attendOptions = Object.entries(response.data.attends).map(
            ([key, value]) => ({
              title: value,
              id: key,
            })
          );
        })
        .catch((error) => {
          console.log(error);
          this.load = false;
        })
        .finally(() => {
          this.processData = false;
        });
    },

    saveLesson(lesson) {
      // Отменяем старые запросы
      let abortControl_;
      while ((abortControl_ = this.abortControl.pop())) {
        abortControl_.abort();
      }

      abortControl_ = new AbortController();
      this.abortControl.push(abortControl_);

      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/secretariat/attendanceReport/saveAttendance",
          new URLSearchParams({
            group_id: this.selectedGroup,
            lesson: JSON.stringify(lesson),
            date: this.day.toLocaleDateString("en-US"),
          }),
          { signal: abortControl_.signal }
        )
        .then((resp) => {
          if (resp.data != null) {
            eventBus.$emit("show-dialog", {
              title: "Ошибка",
              content: "Время сессии истекло, обновите страницу",
            });
          }
          this.abortControl.pop()
        })
        .catch((error) => {
          console.error(error);
          this.abortControl.pop();
        });
    },

    debouncedSaveLesson: debounce(function (lesson) {
      this.saveLesson(lesson);
    }, 500),
  },
};
</script>
<style scoped>
th,
td {
  border: 1px solid #000;
  text-align: center;
  padding: 3px;
}
table > tbody > tr > td:nth-child(2),
table > thead > tr > th:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 1;
  background-color: white;
}
</style>

